var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPgxDrugs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.012014 20.568293",
    id: "svg21",
    width: 23,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .pgx-drugs {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g21",
    transform: "translate(-63.237988,-3.7117074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "pgx-drugs",
    x: 65.300003,
    y: 4.4299998,
    width: 9.2200003,
    height: 19.1,
    rx: 4.0900002,
    ry: 4.0900002,
    transform: "rotate(14.06,69.93007,13.974869)",
    id: "rect4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pgx-drugs",
    d: "M 68.96,8.82 C 69.25,7.65 70.44,6.94 71.6,7.24",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pgx-drugs",
    d: "m 70.86,19.18 c -0.29,1.17 -1.48,1.88 -2.64,1.58",
    id: "path6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "pgx-drugs",
    x1: 74.389999,
    y1: 15.1,
    x2: 65.440002,
    y2: 12.86,
    id: "line6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "pgx-drugs",
    cx: 80.800003,
    cy: 18.83,
    r: 4.6999998,
    id: "circle6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "pgx-drugs",
    x1: 77.480003,
    y1: 22.15,
    x2: 83.510002,
    y2: 16.120001,
    id: "line7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgxDrugs);
export default __webpack_public_path__ + "static/media/PGXDrugs.7d19223c26540d199c0a9c1deae95841.svg";
export { ForwardRef as ReactComponent };